import type { TypeFilterOption } from '@/types/list/types.list.filter';

export const DATE_SHORTCUTS: TypeFilterOption[] = [
    { value: 'today', label: 'Oggi' },
    { value: 'week', label: 'Questa settimana' },
    { value: 'month', label: 'Questo mese' },
];

export const DATE_PRESETS: TypeFilterOption[] = [
    { value: '7d', label: '7 giorni' },
    { value: '30d', label: '30 giorni' },
    { value: '90d', label: '90 giorni' },
    { value: '365d', label: '12 mesi' },
];
